<template lang="html">
  <div v-if="isShowToast" class="toast-container" :class="{'animated fadeInUp':!isHide,'animated fadeOutUp':isHide}" @touchmove.prevent>
    <!-- 这里content为双花括号 -->
    <span class="toast-msg" >{{content}}</span>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isShowToast: true,
            isHide: false,
            content: ""
        };
    },
    methods: {
        show() {
            this.isShowToast = true;
        },
        hide() {
            this.isHide = true;
       
            setTimeout(() => {
                this.isShowToast = false;
            }, 1000);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toast-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    z-index: 1000001;
}
.toast-msg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    padding: 25px;
    border-radius: 5px;
    font-size: 28px;
    line-height: 36px;
    background: rgba(0, 0, 0, 0.6);
    color: rgb(255, 255, 255);
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/toast/toast.vue